import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-767e1d03"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "homebox clearfix"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "center_img"
}, null, -1));

const _hoisted_3 = {
  class: "owin-height"
};
const _hoisted_4 = {
  class: "notice-top"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-icon"
}, null, -1));

const _hoisted_6 = {
  class: "text"
};
const _hoisted_7 = {
  class: "notice-total"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 共 ");

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 条相关内容 ");

const _hoisted_10 = {
  class: "notice-wrapper"
};
const _hoisted_11 = {
  class: "nav-list"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "notice-list-wrapper"
};
const _hoisted_14 = {
  key: 0,
  class: "notice-list"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "left"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  class: "item-info"
};
const _hoisted_19 = ["innerHTML"];
const _hoisted_20 = {
  class: "item-num"
};
const _hoisted_21 = {
  class: "right"
};
const _hoisted_22 = {
  class: "item-time"
};
const _hoisted_23 = {
  class: "progress-box"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  class: "left"
};
const _hoisted_26 = ["title", "innerHTML"];
const _hoisted_27 = ["innerHTML"];
const _hoisted_28 = {
  class: "right notice-count"
};
const _hoisted_29 = {
  class: "view-count"
};

const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 浏览量  ");

const _hoisted_31 = {
  key: 1,
  class: "empty-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Head = _resolveComponent("Head");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_affix = _resolveComponent("el-affix");

  const _component_el_progress = _resolveComponent("el-progress");

  const _component_Empty = _resolveComponent("Empty");

  const _component_el_pagination = _resolveComponent("el-pagination");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Head, {
    menuInfo: $data.menuInfo,
    "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => $data.menuInfo = $event),
    onUserRole: $options.getZhsRole
  }, null, 8, ["menuInfo", "onUserRole"]), _hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", _hoisted_6, _toDisplayString($data.menuInfo.nav_name) + "  ", 1), _withDirectives(_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", null, _toDisplayString($data.pageInfo.rows), 1), _hoisted_9], 512), [[_vShow, $data.showSearchResult]]), _createVNode(_component_el_input, {
    modelValue: $data.newsName,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.newsName = $event),
    size: "default",
    class: "search-input",
    onKeyup: _cache[3] || (_cache[3] = _withKeys($event => $options.handleSearch(), ["enter"])),
    placeholder: "搜索新闻资讯"
  }, {
    suffix: _withCtx(() => [_createElementVNode("i", {
      class: "iconfont icon-sousuo search-icon",
      onClick: _cache[1] || (_cache[1] = $event => $options.handleSearch())
    })]),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_10, [$data.newsTypeList && $data.newsTypeList.length ? (_openBlock(), _createBlock(_component_el_affix, {
    key: 0,
    offset: 0
  }, {
    default: _withCtx(() => [_createElementVNode("ul", _hoisted_11, [_createElementVNode("li", {
      onClick: _cache[4] || (_cache[4] = $event => $options.handleSearch()),
      class: _normalizeClass(["nav", !$data.pageInfo.newsTypeId && 'active'])
    }, " 首页 ", 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsTypeList, ({
      id,
      name
    }) => {
      return _openBlock(), _createElementBlock("li", {
        onClick: $event => $options.handleSearch(id),
        class: _normalizeClass(["nav", $data.pageInfo.newsTypeId === id && 'active']),
        key: id
      }, _toDisplayString(name), 11, _hoisted_12);
    }), 128))])]),
    _: 1
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [$data.newsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsList, item => {
    return _openBlock(), _createElementBlock(_Fragment, null, [item.is_video ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "second-style",
      onClick: $event => $options.showNewsDetail(item)
    }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("img", {
      class: "item-cover",
      src: item.cover_url
    }, null, 8, _hoisted_17), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
      class: "item-title",
      innerHTML: $options.kewordFilter(item.news_name)
    }, null, 8, _hoisted_19), _createElementVNode("div", _hoisted_20, "查看: " + _toDisplayString(item.view_num), 1)])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, "已观看: " + _toDisplayString($options.formatTime(item.watch_time >= item.total_time ? item.total_time : item.watch_time)), 1), _createElementVNode("div", _hoisted_23, [_createVNode(_component_el_progress, {
      percentage: item.progress > 100 ? 100 : item.progress
    }, null, 8, ["percentage"])])])], 8, _hoisted_15)) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "first-style",
      onClick: $event => $options.showNewsDetail(item)
    }, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", {
      class: "notice-title text-overflow",
      title: item.news_name,
      "data-html": "",
      innerHTML: $options.kewordFilter(item.news_name)
    }, null, 8, _hoisted_26), _createElementVNode("div", {
      class: "notice-content text-overflow-two",
      "data-html": "",
      innerHTML: _ctx.$utils.getContentText(item.context)
    }, null, 8, _hoisted_27)]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_hoisted_30, _createElementVNode("span", null, _toDisplayString(item.view_num || 0), 1)]), _createElementVNode("span", null, _toDisplayString($options.dayjs(item.publish_time).format('YYYY-MM-DD')), 1)])], 8, _hoisted_24))], 64);
  }), 256))])) : _createCommentVNode("", true), !$data.newsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_Empty, {
    text: "暂无数据"
  })])) : _createCommentVNode("", true), $data.pageInfo.rows && $data.pageInfo.rows > $data.pageInfo.pageLimit ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 2,
    class: "news-pagination",
    background: "",
    layout: "prev, pager, next",
    "prev-text": "上一页",
    "next-text": "下一页",
    onCurrentChange: $options.pageIndexChange,
    "current-page": $data.pageInfo.pageIndex,
    total: $data.pageInfo.rows,
    "page-size": $data.pageInfo.pageLimit
  }, null, 8, ["onCurrentChange", "current-page", "total", "page-size"])) : _createCommentVNode("", true)])])]), _createVNode(_component_Footer)]);
}